import React, { useState, useEffect } from 'react';
import { SBanner } from '@avalara/skylab-sdk/react';
import { connect } from 'react-redux';
import _ from "lodash";
import QueryString from 'query-string';
import Modal from 'react-responsive-modal';
import Chance from "chance";
import moment from "moment";
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import ERRORSWARNINGS_CONTROLLER from '../../controllers/errorsWarnings';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ErrorsAndWarningsFilterPanel from './FilterPanel';
import { FIELDS as GLOBAL_FILTER_PANEL_FIELDS } from '../filter/GlobalFilterPanel';
import ComponentUtil from '../../utils/componentUtil';
import ExistingErrorsWarnings, { ROW_ACTIONS } from './ExistingErrorsWarnings';
import ENUMS, { ErrorWarningsCategory, ErrorKind, ErrorWarningAction, FilingTypeEnum, ReportType } from '../../utils/enums';
import ExistingCategories from './ExistingCategories';
import BulkReplacePanel from './BulkReplacePanel';
import StaticApplicationMessage from '../inAppMessages/StaticApplicationMessage';
import { ErrorsWarningsConfig } from '../../utils/appConfig';
import CorrectivesPanel from './correctives/CorrectivesPanel';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../utils/logger';
import BusySpinner from '../spinners/BusySpinner';
import ReschedulePanel from './correctives/ReschedulePanel';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import { getNonCorrectiveTypes, getOssReturnTypes } from "../../utils/featureFlagMappingForReturnType";

const FORM_NAME = 'ERRORS_WARNINGS_PAGE';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const INVALID_RESCHEDULE_PERIOD_STATUS = "InvalidReschedulePeriod";

const chance = new Chance();

const PAGE_INTERNAL_IDS = [
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID
];
const FULL_SCREEN_MODAL_CLASSNAMES = {
    modal: 'modal-full-width-height modal-max-width-100 full-screen-modal',
    overlay: 'modal-overlay-padding-none'
};

const STANDARD_MODAL_CLASSNAMES = {
    modal: 'modal-full-width',
};

const CORRECTIVES_MODAL_CLASSNAMES = {
    modal: 'modal-max-width-85',
};

const RESCHEDULE_MODAL_CLASSNAMES = {
    modal: 'modal-full-width mt150',
};

const errorTransactionsForClosedFiling = 58;

const allowedTypesRescheduleCorrection = [
    ...getOssReturnTypes(),
    FilingTypeEnum.VATRETURN,
    FilingTypeEnum.VATBOOKS,
    FilingTypeEnum.ECLISTING
];

const ErrorsAndWarningsPage = (props) => {
    const [errorData, setErrorData] = useState(props.errorData || []);
    const [warningData, setWarningData] = useState([])
    const [collapseAll, setCollapseAll] = useState(false)
    const [showErrorListModal, setShowErrorListModal] = useState(false);
    const [stateShowErrorWarningActionModal, setShowErrorWarningActionModal] = useState(false);
    const [errorWarningActionData, setErrorWarningActionData] = useState({});
    const [showCategoryActionModal, setShowCategoryActionModal] = useState(false);
    const [selectedAction, setSelectedAction] = useState('select');
    const [selectedSubCategoryInfo, setSelectedSubCategoryInfo] = useState({ type: ErrorKind.UNKNOWN, data: {} });
    const [selectedErrorCount, setSelectedErrorCount] = useState(0);
    const [selectedWarningCount, setSelectedWarningCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [subCategoriesLoading, setSubCategoriesLoading] = useState([]);
    const [showCorrectivesModal, setShowCorrectivesModal] = useState(false);
    const [performOnPageLoad, setPerformOnPageLoad] = useState(true);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);
    const [showSpinner, setShowSpinner] = useState(false);
    const [filingTypeEnabledForRescheduleCorrection, setfilingTypeEnabledForRescheduleCorrection] = useState(false);

    const [stateShowReopenedClosedReturnsSuccess, setShowReopenedClosedReturnsSuccess] = useState(false);
    const [showRescheduleCorrectivesModal, setRescheduleCorrectivesModal] = useState(false);
    const [showRescheduleNonCorrectivesModal, setRescheduleNonCorrectivesModal] = useState(false);
    const [selectedFilingType, setSelectedFilingType] = useState(null);

    const categorySelectionHandler = (selection, errorType, newSelectedErrorCount, newSelectedWarningCount, selectedFilingType) => {
        log.debug('categorySelectionHandler(): ', selection, errorType, newSelectedErrorCount, newSelectedWarningCount);
        setSelectedFilingType(selectedFilingType);
        // Convert the selection Map into an array so we can store it in Redux.
        const selectionArray = Array.from(selection, (item) => ({ key: item[0], value: item[1] }));
        props.setSelection(selectionArray);
        setSelectedErrorCount(newSelectedErrorCount);
        setSelectedWarningCount(newSelectedWarningCount);
    }

    const getSelectedCompany = () => {
        log.debug('getSelectedCompany()');
        if (_.isEmpty(props.companies)) {
            return {};
        }
        const globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll() || {};
        const matchedCompany = props.companies.find(company => globalFilterValues.companyCode === company.code);
        log.debug('getSelectedCompany(): matchedCompany: ', matchedCompany);
        return matchedCompany;
    };

    const openErrorListModal = () => {
        log.debug('openErrorListModal()');
        setCollapseAll(false);
        setShowErrorListModal(true);
    };

    const closeErrorListModal = () => {
        log.debug('closeErrorListModal()');
        setCollapseAll(true);
        setShowErrorListModal(false);
        setLoading(true);
    };

    const onErrorListModalClose = () => {
        closeErrorListModal();
        resetToDefaults();
        onPageLoad();
    }

    const openCorrectivesModal = () => {
        props.doGetReopenableClosedReturns();
        setShowCorrectivesModal(true);
    };

    const closeCorrectivesModal = () => {
        setShowCorrectivesModal(false);
        setSelectedAction('selected');
        if (performOnPageLoad) { onPageLoad(); }
    };

    const openRescheduleNonCorrectivesModal = (filterCriteria, selectedCategory) => {
        const params = {
            companyId: filterCriteria.companyId === 'All' ? 0 : filterCriteria.companyId,
            countryCode: '',
            endDate: filterCriteria.endDate,
            errorCategory: filterCriteria.errorCategory?.value,
            errorCodeId: selectedCategory.codeId,
            filingType: selectedCategory.filingType,
            pageNumber: 1,
            startDate: filterCriteria.startDate,
            subType: selectedCategory.subTypeSearchValue
        }
        if (getNonCorrectiveTypes().includes(selectedFilingType)) {
            props.doLoadErrors(params, () => {
                setRescheduleNonCorrectivesModal(true);
            });
        }
    }

    const openRescheduleCorrectivesModal = (filterCriteria, selectedCategory) => {
        const params = {
            companyId: filterCriteria.companyId === 'All' ? 0 : filterCriteria.companyId,
            countryCode: '',
            endDate: filterCriteria.endDate,
            errorCategory: filterCriteria.errorCategory?.value,
            errorCodeId: selectedCategory.codeId,
            filingType: selectedCategory.filingType,
            pageNumber: 1,
            startDate: filterCriteria.startDate,
            subType: selectedCategory.subTypeSearchValue
        };

        if (allowedTypesRescheduleCorrection.includes(selectedFilingType)) {
            props.doLoadErrors(params, () => {
                setRescheduleCorrectivesModal(true);
            });
        }
    };

    const closeRescheduleCorrectivesModal = () => {
        setRescheduleCorrectivesModal(false);
    };

    const closeRescheduleNonCorrectivesModal = () => {
        setRescheduleNonCorrectivesModal(false);
    };

    const submitRescheduleCorrectives = (newTransactionDate) => {
        if (allowedTypesRescheduleCorrection.includes(selectedFilingType)) {
            if (props.transactionErrors && Array.isArray(props.transactionErrors)) {
                props.doRescheduleCorrectionV3([props.transactionErrors?.[0].id], newTransactionDate, () => {
                    onPageLoad();
                    closeRescheduleCorrectivesModal();
                }, (error) => {
                    if (error && error.statusText === INVALID_RESCHEDULE_PERIOD_STATUS) {
                        log.setDictionaryMessage(ALL_MESSAGES.INVALID_CORRECTION_PERIOD);
                    } else {
                        log.setDictionaryMessage(ALL_MESSAGES.FAILED_RESCHEDULE_CORRECTION);
                    }
                    closeRescheduleCorrectivesModal();
                });
            }
        }
    }

    const submitRescheduleNonCorrectives = (newTransactionDate) => {
        if (getNonCorrectiveTypes().includes(selectedFilingType)) {
            if (props.transactionErrors && Array.isArray(props.transactionErrors)) {
                props.doRescheduleNonCorrectionLatest([props.transactionErrors?.[0].id], newTransactionDate, () => {
                    onPageLoad();
                    closeRescheduleNonCorrectivesModal();
                }, (error) => {
                    if (error && error.statusText === INVALID_RESCHEDULE_PERIOD_STATUS) {
                        log.setDictionaryMessage(ALL_MESSAGES.INVALID_NON_CORRECTION_PERIOD);
                    } else {
                        log.setDictionaryMessage(ALL_MESSAGES.FAILED_RESCHEDULE_NON_CORRECTION);
                    }
                    closeRescheduleNonCorrectivesModal();
                });
            }
        }
    }

    const reopenClosedReturns = (returnsToReopen) => {
        if (returnsToReopen && returnsToReopen.length > 0) {
            // 1. Start spinnner
            setShowSpinner(true);

            // 2. Call api to reopen return/s
            props.doReopenClosedReturns(
                returnsToReopen,
                () => {
                    setShowSpinner(false);

                    redeliverSelectedTransactions();

                    log.setDictionaryMessage(ALL_MESSAGES.ERRORS_WARNINGS_REOPENED);
                },
                () => {
                    setShowSpinner(false);

                    redeliverSelectedTransactions();

                    log.setDictionaryMessage(ALL_MESSAGES.ERRORS_WARNINGS_REOPEN_PARTIAL_FAILURE);
                },
                () => {
                    setShowSpinner(false);
                    log.setDictionaryMessage(ALL_MESSAGES.ERRORS_WARNINGS_REOPEN_FAILURE);
                }
            );
        }

        // Close the modal and clean up.
        closeCorrectivesModal();
        if (!performOnPageLoad) {
            closeErrorListModal();
            onPageLoad();
        }
    };

    const redeliverSelectedTransactions = () => {
        const filterCriteria = buildFilterCriteria();
        // Convert selection from redux back to a Map
        let selection = new Map();
        props.selection.forEach(selected => selection.set(selected.key));
        const actionableData = mapErrorWarningCodeIdsToData(selection, ErrorKind.ERROR);
        actionableData.forEach(data => {
            const apiParams = buildActionApiParams(filterCriteria, data, ErrorKind.ERROR);
            errorAction(ErrorWarningAction.ERROR_ACTION_MOVE.value, apiParams, false);
        });
    };

    const openCategoryActionModal = () => {
        log.debug('openCategoryActionModal()');
        setShowCategoryActionModal(true);
    };

    const onCategoryActionModalClose = () => {
        setShowCategoryActionModal(false);
        setErrorWarningActionData({});
        resetToDefaults();
    };

    const onBulkReplacePanelApply = (errorIds, replaceTagValues) => {
        const newErrorWarningActionData = errorWarningActionData || {};
        log.debug('onBulkReplacePanelApply() - errorIds: %s, replaceTagValues: %s', errorIds, replaceTagValues);
        props.doActionOnFilters(ErrorWarningAction.ERROR_ACTION_MOVE.value, newErrorWarningActionData.filterCriteria, replaceTagValues, (errors, data) => {
            log.debug('onBulkReplacePanelApply() -> doApplyErrorsActions() -> callback(): ', errors, data);
            onCategoryActionModalClose();
            onPageLoad();
            setCollapseAll(false);
            setLoading(true);
        });
    };

    const getParsedQueryParams = () => {
        let parsedQueryParams = QueryString.parse(props.location.search) || {};
        if (!_.has(parsedQueryParams, 'includeErrors')) {
            parsedQueryParams.includeErrors = 'true';
        }
        if (!_.has(parsedQueryParams, 'errorCategory')) {
            parsedQueryParams.errorCategory = LANGUAGES_CONTROLLER.format(props.languages, ErrorWarningsCategory.ALL_ERRORS.languageString);
        }
        return parsedQueryParams;
    };

    const getErrorWarningsCategoryEnumByLanguage = (value) => {
        return ErrorWarningsCategory.enumValues.find((enumEntry) => {
            return LANGUAGES_CONTROLLER.format(props.languages, enumEntry.languageString) === value;
        });
    };

    const getDefaultFilterCriteria = () => {
        return {
            includeWarnings: 'false',
            includeErrors: 'true'
        };
    };

    const searchClickHandler = (searchFilterCriteria) => {
        log.debug('searchClickHandler() - filterCriteria: ', searchFilterCriteria);
        if (!_.isEmpty(searchFilterCriteria)) {
            resetToDefaults();
            props.doUnload('errorCategories');
            props.doUnload('warningCategories');
            const apiParams = Object.assign({}, searchFilterCriteria);
            PAGE_INTERNAL_IDS.forEach(key => delete searchFilterCriteria[key]);
            ComponentUtil.updateUrlParams(props.location, props.history, searchFilterCriteria);
            if (`${searchFilterCriteria.includeErrors}` === 'true') {
                loadErrorCategories(apiParams);
            }
            if (`${searchFilterCriteria.includeWarnings}` === 'true') {
                loadWarningCategories(apiParams);
            }
        }
    };

    const loadErrorCategories = (filterCriteria) => {
        log.debug('loadErrorCategories() - filterCriteria: ', filterCriteria);
        let apiParams = Object.assign({}, filterCriteria);
        apiParams.errorCategory = getErrorWarningsCategoryEnumByLanguage(filterCriteria.errorCategory);
        props.doLoadErrorCategories(apiParams);
    };

    const loadWarningCategories = (filterCriteria) => {
        log.debug('loadWarningCategories() - filterCriteria: ', filterCriteria);
        let apiParams = Object.assign({}, filterCriteria);
        apiParams.errorCategory = getErrorWarningsCategoryEnumByLanguage(filterCriteria.errorCategory);
        props.doLoadWarningCategories(apiParams);
    };

    const resetToDefaults = () => {
        setCollapseAll(true);
        setSelectedAction('select');
    };

    const onErrorListModalActionClick = (type, action, data, event, categoryRow) => {
        log.debug('onErrorListModalActionClick(): ', type, action, data, event);
        const filingTypesEnabledForCorrection = [ENUMS.getFilingNameFromFilingType(FilingTypeEnum.VATRETURN)];
        setfilingTypeEnabledForRescheduleCorrection(false);
        filingTypesEnabledForCorrection.forEach((key) => {
            if (data?.original.codeId === errorTransactionsForClosedFiling && data?.original.subType.startsWith(key)) {
                setfilingTypeEnabledForRescheduleCorrection(true);
            }
        })
        const original = data ? data.original : {};
        const filingType = ENUMS.getFilingTypeFromSubType(original?.subType);
        setSelectedFilingType(filingType);
        let filterCriteria = getParsedQueryParams();
        filterCriteria.errorCategory = getErrorWarningsCategoryEnumByLanguage(filterCriteria.errorCategory);
        setSelectedSubCategoryInfo({
            type: type,
            data: Object.assign({ company: getSelectedCompany(), filterCriteria: filterCriteria }, original),
            row: data,
            categoryRow: categoryRow
        });
        setPerformOnPageLoad(false);
        switch (action) {
            case ROW_ACTIONS.VIEW_AND_RESOLVE:
                openErrorListModal();
                break;
            default:
                break;
        }
    };

    const loadSubcategories = (newSelectedRowIndex, original, pagination, type, cb = () => { }) => {
        log.debug('loadSubcategories(): Viewing row @ index: ', newSelectedRowIndex);
        log.clearDictionaryError(ALL_MESSAGES.ERRORS_WARNINGS_ACTION_RECORDS_SKIPPED);
        log.clearDictionaryError(ALL_MESSAGES.ERRORS_WARNINGS_REOPENED);
        log.clearDictionaryError(ALL_MESSAGES.ERRORS_WARNINGS_REOPEN_PARTIAL_FAILURE);
        log.clearDictionaryError(ALL_MESSAGES.ERRORS_WARNINGS_REOPEN_FAILURE);
        const parsedQueryParams = getParsedQueryParams();
        const globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll();
        const filterCriteria = Object.assign({}, parsedQueryParams, globalFilterValues, {
            errorCodeId: original.codeId,
            subType: original.subTypeSearchValue,
            errorCategory: original.errorCategory,
            pageNumber: pagination.pageNumber,
            pageSize: pagination.pageSize
        });
        let newSubCategoriesLoading = [...subCategoriesLoading];
        newSubCategoriesLoading[newSelectedRowIndex] = true;
        setSubCategoriesLoading(newSubCategoriesLoading);
        if (type === ErrorKind.ERROR) {
            props.doLoadErrorSubCategories(filterCriteria, (error, data) => {
                let newErrorData = [...errorData];
                newErrorData[newSelectedRowIndex] = Object.assign({}, newErrorData[newSelectedRowIndex], { subCategories: data });
                let newSubCategoriesLoading = [...subCategoriesLoading];
                newSubCategoriesLoading[newSelectedRowIndex] = false;
                setErrorData(newErrorData)
                setSelectedRowIndex(newSelectedRowIndex);
                setSelectedErrorCount(0);
                setSubCategoriesLoading(newSubCategoriesLoading);
                cb(error, data);
            }, false);
        } else if (type === ErrorKind.WARNING) {
            props.doLoadWarningSubCategories(filterCriteria, (error, data) => {
                let newWarningData = [...warningData];
                newWarningData[newSelectedRowIndex] = Object.assign({}, newWarningData[newSelectedRowIndex], { subCategories: data });
                let newSubCategoriesLoading = [...subCategoriesLoading];
                newSubCategoriesLoading[newSelectedRowIndex] = false;
                setWarningData(newWarningData);
                setSelectedRowIndex(newSelectedRowIndex);
                setSelectedErrorCount(0);
                setSubCategoriesLoading(newSubCategoriesLoading);
                cb(error, data);
            }, false);
        }
    };

    const onSubCategoryFetchData = (pagination, errorCategoryRowData) => {
        log.debug('onSubCategoryFetchData(): ', pagination, errorCategoryRowData);
        const original = errorCategoryRowData.original || {};
        loadSubcategories(errorCategoryRowData.index, original, pagination, ErrorKind.enumValueOf(original.type.toUpperCase()));
    }

    const mapErrorWarningCodeIdsToData = (keys, type, keyField = '_id') => {
        const data = (type === ErrorKind.ERROR ? errorData : warningData);
        if (_.isEmpty(keys) || _.isEmpty(data)) {
            return [];
        }
        return data.filter(entry => keys.has(entry[keyField]));
    };

    const buildActionApiParams = (filterCriteria, errorData, type) => ({
        "companyId": (typeof filterCriteria.companyId === 'undefined' || filterCriteria.companyId == 'All') ? 0 : filterCriteria.companyId,
        "countryCode": filterCriteria.countryCode,
        "startDate": filterCriteria.startDate,
        "endDate": filterCriteria.endDate,
        "maxNrOfErrors": 0,
        "pageNumber": 0,
        "errorCategory": errorData.errorCategory,
        "includeHidden": filterCriteria.includeHidden,
        "groupBy": 1,
        "errorTreeLevel": 2,
        "includeErrors": type === ErrorKind.ERROR,
        "includeWarnings": type === ErrorKind.WARNING,
        "errorType": errorData.codeId,
        "subType": errorData.subType,
        "invoiceNumberFilter": filterCriteria.invoiceNumberFilter
    });

    const errorAction = (errorAction, apiParams, pageLoad = true) => {
        props.doActionOnFilters(errorAction, apiParams, [], (errors, successes) => {
            log.debug('categoryActionClickHandler() -> doActionOnFilters() -> callback(): ', errors, successes);
            setCollapseAll(true);
            setLoading(true);
            resetToDefaults();
            onPageLoad(false);
        });
    };

    const buildFilterCriteria = () => {
        const parsedQueryParams = getParsedQueryParams();
        const globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll();
        let filterCriteria = Object.assign({}, parsedQueryParams, globalFilterValues);
        filterCriteria.errorCategory = getErrorWarningsCategoryEnumByLanguage(filterCriteria.errorCategory);

        return filterCriteria;
    };

    const categoryActionClickHandler = (action, type, selection, selectedCategory) => {
        if (_.isEmpty(selection) || _.isEmpty(type)) {
            return;
        }
        const filterCriteria = buildFilterCriteria();

        // What is this for?
        const actionableData = mapErrorWarningCodeIdsToData(selection, type);
        actionableData.forEach((data, codeId, map) => {
            const apiParams = buildActionApiParams(filterCriteria, data, type);
            switch (action) {
                //TODO: Export currently not supported on all, uncomment after API fixes are done
                //  case ErrorWarningAction.EXPORT:
                //     apiParams = {
                //         "companyId": filterCriteria.companyId,
                //         "countryCode": filterCriteria.countryCode || '',
                //         "startDate": filterCriteria.startDate || '',
                //         "endDate": filterCriteria.endDate || '',
                //         "subType": data.subTypeSearchValue,
                //         "errorCategory": data.errorCategory,
                //         "errorCodeId": data.codeId,
                //         "maxErrorCount": 0,
                //         "pageNumber": 0
                //     };
                //     type === ErrorKind.ERROR ?
                //         props.doDownloadErrors(apiParams, () => {
                //             //Do nothing
                //         }):
                //         props.doDownloadWarnings(apiParams, () => {
                //             //Do nothing
                //         });
                //     break;

                case ErrorWarningAction.REOPEN_AND_REDELIVER:
                    openCorrectivesModal();
                    break;
                case ErrorWarningAction.RESCHEDULE_AS_NONCORRECTIVE:
                    openRescheduleNonCorrectivesModal(filterCriteria, selectedCategory);
                    break;
                case ErrorWarningAction.RESCHEDULE_AS_CORRECTIVE:
                    openRescheduleCorrectivesModal(filterCriteria, selectedCategory);
                    break;
                case ErrorWarningAction.BULK_FIND_AND_REPLACE:
                    props.doLoadWizardNodes();
                    setErrorWarningActionData({
                        action: ErrorWarningAction.BULK_FIND_AND_REPLACE,
                        type: type,
                        filterCriteria: apiParams
                    });
                    openCategoryActionModal();
                    break;
                case ErrorWarningAction.ERROR_ACTION_VATRATE:
                case ErrorWarningAction.ERROR_ACTION_INVNR:
                case ErrorWarningAction.ERROR_ACTION_SUPINVNR:
                case ErrorWarningAction.ERROR_ACTION_VATNR:
                case ErrorWarningAction.ERROR_ACTION_MOVE:
                case ErrorWarningAction.ERROR_ACTION_DELETE:
                case ErrorWarningAction.ERROR_ACTION_MOVE_WARNING_TO_ERROR:
                case ErrorWarningAction.ERROR_ACTION_OSS_VATNR:
                    //case ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE: // TODO: Not supported yet by the API
                    log.debug('categoryActionClickHandler(): ', action, apiParams);
                    errorAction(action.value, apiParams);
                    break;
                default:
                    return;
            }
        });
    };

    const onPageLoad = (clearErrors = true) => {
        log.debug('onPageLoad(): ');
        if (clearErrors) log.clearAllDictionaryErrors();
        const parsedQueryParams = getParsedQueryParams();
        const globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll();
        let filterCriteria = Object.assign({}, parsedQueryParams, globalFilterValues);
        if (!_.isEmpty(filterCriteria)) {
            const apiParams = Object.assign({}, filterCriteria);
            PAGE_INTERNAL_IDS.forEach(key => delete filterCriteria[key]);
            ComponentUtil.updateUrlParams(props.location, props.history, filterCriteria);
            if ((apiParams.companyCode !== undefined && apiParams.companyId !== undefined)
                || (apiParams.companyCode === undefined && apiParams.companyId === undefined) || apiParams.companyId == 'All') {
                delete apiParams.companyCode;
                if (apiParams.companyId === undefined || apiParams.companyId == 'All') {
                    apiParams.companyId = 0;
                }
                if (`${filterCriteria.includeErrors}` === 'true') {
                    loadErrorCategories(apiParams);
                } else {
                    props.doUnload('errorCategories');
                }
                if (`${filterCriteria.includeWarnings}` === 'true') {
                    loadWarningCategories(apiParams);
                } else {
                    props.doUnload('warningCategories');
                }
            }
        }
    };

    const handleExportErrorWarning = (params, filterCriteria) => {
        const errorCategory = getErrorWarningsCategoryEnumByLanguage(filterCriteria.errorCategory);
        const companyId = (typeof filterCriteria.companyId === 'undefined' || filterCriteria.companyId == 'All') ? 0 : parseInt(filterCriteria.companyId);
        const reqParams = {
            ...params,
            tenantId: props.customerId,
            companyCode: filterCriteria.companyCode,
            companyId: companyId,
            countryCode: filterCriteria.countryCode,
            endDate: filterCriteria.endDate,
            errorCategory: errorCategory && errorCategory.value,
            includeHidden: filterCriteria.includeHidden,
            startDate: filterCriteria.startDate,
            invoiceNumberFilter: filterCriteria.invoiceNumberFilter,
            invoiceNumberFilterExactMatch: filterCriteria.invoiceNumberFilterExactMatch,
            type: ReportType.ERROR_WARNINGS,
            userName: props.userName
        };
        props.doExportErrorsWarnings(reqParams);
    }

    useEffect(() => {
        log.debug('useEffect []: location.search:', props.location.search);
        onPageLoad();
        return () => { props.doUnload() };
    }, []);

    useEffect(() => {
        let newErrorData = [];
        if (!_.isEmpty(props.errorCategories)) {
            newErrorData = [...props.errorCategories];
        }
        setErrorData(newErrorData.map(o => {
            o._id = chance.guid();
            return o;
        }));
        setCollapseAll(true);
        setSelectedSubCategoryInfo({
            type: ErrorKind.UNKNOWN,
            data: {}
        });
        setSelectedErrorCount(0);
        setSelectedAction('select');
        setLoading(false);
    }, [props.errorCategories]);

    useEffect(() => {
        let newWarningData = [];
        if (!_.isEmpty(props.warningCategories)) {
            newWarningData = [...props.warningCategories];
        }
        setWarningData(newWarningData.map(o => {
            o._id = chance.guid();
            return o;
        }));
        setCollapseAll(true);
        setSelectedAction('select');
        setSelectedWarningCount(0);
        setSelectedSubCategoryInfo({
            type: '',
            data: {}
        });
        setLoading(false);
    }, [props.warningCategories]);

    log.debug('render(): ', props);
    log.debug('render(): location.search:', props.location.search);
    const globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
    let filterCriteria = Object.assign({}, globalFilterSelection, QueryString.parse(props.location.search));
    log.debug('render(): queryParams', filterCriteria);
    if (_.isEmpty(filterCriteria)) {
        filterCriteria = getDefaultFilterCriteria();
    }
    const totalSelectedCount = selectedErrorCount + selectedWarningCount;
    return (
        <>
            <BusySpinner busy={showSpinner} />
            <s-container class="mb50">
                <ReadOnlyWrapper>
                    <div className="content-area">
                        <h1><LanguageStringResolver string="PageName_ErrorsAndWarnings" /></h1>
                        <ApplicationMessages scope={[FORM_NAME]} messageType="applicationError" />
                        <ApplicationMessages
                            messageIds={[ALL_MESSAGES.ERRORS_WARNINGS_ACTION_RECORDS_SKIPPED]}
                            messageType="applicationWarning"
                        />
                        <ApplicationMessages
                            messageIds={[ALL_MESSAGES.ERRORS_WARNINGS_REOPENED]}
                            messageType="applicationSuccess" />

                        {
                            totalSelectedCount > ErrorsWarningsConfig.MAX_PROCESSING_LIMIT ? (
                                <StaticApplicationMessage
                                    messageType="applicationWarning"
                                    string="errorsWarningsPage_MaxRecordsLimitWarning"
                                    languages={props.languages}
                                    params={[ErrorsWarningsConfig.MAX_PROCESSING_LIMIT]} />
                            ) : (<span></span>)
                        }
                        {
                            stateShowReopenedClosedReturnsSuccess ?
                                <SBanner
                                    id="banner-reopenedSuccess"
                                    aria-label="Successfully reopened closed returns"
                                    status="success"
                                    onS-dismiss={() => setShowReopenedClosedReturnsSuccess(false)}>
                                    <span><LanguageStringResolver string="correctives_reopenedClosedReturnsSuccess" /></span>
                                </SBanner>
                                : <></>
                        }
                        <ErrorsAndWarningsFilterPanel
                            countryList={props.countryList}
                            includeErrors={filterCriteria.includeErrors !== undefined ? `${filterCriteria.includeErrors}` : 'false'}
                            includeWarnings={filterCriteria.includeWarnings !== undefined ? `${filterCriteria.includeWarnings}` : 'false'}
                            includeHidden={filterCriteria.includeHidden !== undefined ? `${filterCriteria.includeHidden}` : 'false'}
                            errorCategory={`${filterCriteria.errorCategory}`}
                            invoiceNumberFilter={filterCriteria.invoiceNumberFilter}
                            onSearchClick={searchClickHandler.bind(this)}
                            onFilterChange={() => props.resetExportAllToast()}
                        />
                        <div />
                        <ExistingCategories
                            errorData={errorData}
                            warningData={warningData}
                            showErrors={`${filterCriteria.includeErrors}` === 'true'}
                            showWarnings={`${filterCriteria.includeWarnings}` === 'true'}
                            onActionClick={onErrorListModalActionClick.bind(this)}
                            onFetchData={onSubCategoryFetchData.bind(this)}
                            onCategoryActionClick={categoryActionClickHandler.bind(this)}
                            collapseAll={collapseAll}
                            selectedAction={selectedAction}
                            onSelectionChange={categorySelectionHandler.bind(this)}
                            loading={loading}
                            disableActions={totalSelectedCount > 1000}
                            subCategoriesLoading={subCategoriesLoading}
                            onExportAllToCSVClick={(params) => handleExportErrorWarning(params, filterCriteria)}
                            onResetToastClick={() => props.resetExportAllToast()}
                            selectedFilingType={selectedFilingType}
                        />
                    </div>
                    <div>
                        <Modal
                            classNames={FULL_SCREEN_MODAL_CLASSNAMES}
                            open={showErrorListModal}
                            onClose={onErrorListModalClose.bind(this)}
                            closeOnEsc={true}
                            blockScroll={true}
                            closeOnOverlayClick={false}
                            center
                        >

                            {
                                showErrorListModal ? (
                                    <ExistingErrorsWarnings
                                        keyField='id'
                                        filingTypeEnabledForRescheduleCorrection={filingTypeEnabledForRescheduleCorrection}
                                        parsedQueryParams={getParsedQueryParams.bind(this)}
                                        subCategoryInfo={selectedSubCategoryInfo}
                                        onErrorWarningActionClick={() => { }}
                                        postErrorWarningAction={() => { }}
                                        onNoData={() => {
                                            closeErrorListModal();
                                            closeErrorListModal();
                                            resetToDefaults();
                                            onPageLoad();
                                        }
                                        }
                                        openCorrectivesModal={openCorrectivesModal.bind(this)}
                                        selectedFilingType={selectedFilingType}
                                    />
                                ) : (<span></span>)
                            }
                        </Modal>
                    </div>
                    <div>
                        <Modal
                            classNames={STANDARD_MODAL_CLASSNAMES}
                            open={showCategoryActionModal}
                            onClose={onCategoryActionModalClose.bind(this)}
                            closeOnEsc={true}
                            blockScroll={true}
                            closeOnOverlayClick={false}
                            center
                        >
                            <div>
                                <BulkReplacePanel
                                    errorList={[]}
                                    filename={`ExportedErrorsAndWarnings-${moment.utc(new Date()).format('YYYY-MM-DD')}.csv`}
                                    nodeList={props.nodeWizardNodes || []}
                                    onCancel={onCategoryActionModalClose.bind(this)}
                                    onApply={onBulkReplacePanelApply.bind(this)}
                                />
                            </div>
                        </Modal>
                    </div>
                    <div>
                        <Modal classNames={CORRECTIVES_MODAL_CLASSNAMES}
                            open={showCorrectivesModal}
                            onClose={closeCorrectivesModal.bind(this)}>
                            <CorrectivesPanel
                                reopenableClosedReturns={props.reopenableClosedReturns}
                                onClose={closeCorrectivesModal.bind(this)}
                                onSubmit={reopenClosedReturns.bind(this)}
                                languages={props.languages} />
                        </Modal>
                    </div>
                    <div>
                        <Modal classNames={RESCHEDULE_MODAL_CLASSNAMES}
                            open={showRescheduleCorrectivesModal}
                            onClose={closeRescheduleCorrectivesModal}>
                            <ReschedulePanel
                                onClose={closeRescheduleCorrectivesModal}
                                onSubmit={submitRescheduleCorrectives}
                                title="rescheduleCorrectives_header"
                            />
                        </Modal>
                    </div>
                    <div>
                        <Modal classNames={RESCHEDULE_MODAL_CLASSNAMES}
                            open={showRescheduleNonCorrectivesModal}
                            onClose={closeRescheduleNonCorrectivesModal}>
                            <ReschedulePanel
                                onClose={closeRescheduleNonCorrectivesModal}
                                onSubmit={submitRescheduleNonCorrectives}
                                title="rescheduleNonCorrectives_header"
                            />
                        </Modal>
                    </div>
                </ReadOnlyWrapper>
            </s-container>
        </>
    );
}

export function mapStateToProps(state) {
    log.debug('mapStateToProps(): ');
    let stateProps = {};
    stateProps.languages = state.languages;
    stateProps.companies = state.companies && state.companies.data;
    if (typeof state.errorsWarnings === 'undefined') {
        return stateProps;
    }
    stateProps.errorCategories = state.errorsWarnings.errorCategories;
    stateProps.warningCategories = state.errorsWarnings.warningCategories;
    stateProps.reopenableClosedReturns = state.errorsWarnings.reopenableClosedReturns;
    stateProps.nodeWizardNodes = _.isArray(state.errorsWarnings.nodeWizardNodes)
        && state.errorsWarnings.nodeWizardNodes.map(n => n.nodeName);
    stateProps.countryList = (state.content && state.content.contentData && state.content.contentData.countryList)
    stateProps.selection = state.errorsWarnings.selection;
    stateProps.customerId = state.authentication && state.authentication.data && state.authentication.data.customerId;
    stateProps.userName = (state.authentication && state.authentication.data && state.authentication.data.userName) || "Unknown";
    stateProps.transactionErrors = state.errorsWarnings.transactionErrors;
    log.debug('mapStateToProps(): stateProps: ', stateProps);
    return stateProps;
}

export function mapDispatchersToProps(dispatch) {
    let dispatcherProps = {};

    dispatcherProps.doClearErrorsAndWarnings = () => {
        log.debug('doClearErrorsAndWarnings()');
        dispatch(ERRORSWARNINGS_CONTROLLER.clearErrorsAndWarnings());
    };

    dispatcherProps.doUnload = (dataName = '') => {
        log.debug('doUnload()');
        dispatch(ERRORSWARNINGS_CONTROLLER.doUnload(dataName));
    };

    dispatcherProps.doLoadWizardNodes = () => {
        log.debug('doLoadWizardNodes()');
        dispatch(ERRORSWARNINGS_CONTROLLER.doLoadNodeWizardNodes());
    };

    dispatcherProps.doGetReopenableClosedReturns = () => {
        log.debug('doGetReopenableClosedReturns()');
        dispatch(ERRORSWARNINGS_CONTROLLER.doGetReopenableClosedReturns());
    };

    dispatcherProps.doReopenClosedReturns = (params, success, partialFailure, failure) => {
        log.debug('doReopenClosedReturns()');
        dispatch(ERRORSWARNINGS_CONTROLLER.doReopenClosedReturns(params, success, partialFailure, failure));
    };

    dispatcherProps.doLoadErrorCategories = (filterParams = {}) => {
        log.debug('doLoadErrorCategories() : filterParams: ', filterParams);
        const modifiedFilterParams = Object.assign({}, filterParams, {
            includeErrors: undefined,
            includeWarnings: undefined,
            errorCategory: filterParams.errorCategory ? filterParams.errorCategory.value : ErrorWarningsCategory.ALL_ERRORS.value,
            //make companyId=0 for default on page selection or All selection
            companyId: (typeof filterParams.companyId === 'undefined' || filterParams.companyId == 'All') ? 0 : filterParams.companyId
        });
        log.debug('doLoadErrorCategories: ', modifiedFilterParams);
        dispatch(ERRORSWARNINGS_CONTROLLER.doLoadErrorCategories(modifiedFilterParams));
    };

    dispatcherProps.doLoadErrorSubCategories = (filterParams = {}, callback = () => { }, loading = true) => {
        log.debug('doLoadErrorSubCategories() : filterParams: ', filterParams);
        const modifiedFilterParams = Object.assign({}, filterParams, {
            includeErrors: undefined,
            includeWarnings: undefined,
            companyId: (typeof filterParams.companyId === 'undefined' || filterParams.companyId == 'All') ? 0 : filterParams.companyId
        });
        log.debug('doLoadErrorSubCategories: ', modifiedFilterParams);
        dispatch(ERRORSWARNINGS_CONTROLLER.doLoadErrorSubCategories(modifiedFilterParams, callback, loading));
    };

    dispatcherProps.doLoadWarningCategories = (filterParams = {}) => {
        log.debug('doLoadWarningCategories() : filterParams: ', filterParams);
        const modifiedFilterParams = Object.assign({}, filterParams, {
            includeErrors: undefined,
            includeWarnings: undefined,
            errorCategory: filterParams.errorCategory ? filterParams.errorCategory.value : ErrorWarningsCategory.ALL_ERRORS.value,
            companyId: (typeof filterParams.companyId === 'undefined' || filterParams.companyId == 'All') ? 0 : filterParams.companyId
        });
        log.debug('doLoadWarningCategories: ', modifiedFilterParams);
        dispatch(ERRORSWARNINGS_CONTROLLER.doLoadWarningCategories(modifiedFilterParams));
    };

    dispatcherProps.doLoadWarningSubCategories = (filterParams = {}, callback = () => { }, loading = true) => {
        log.debug('doLoadWarningSubCategories() : filterParams: ', filterParams);
        const modifiedFilterParams = Object.assign({}, filterParams, {
            includeErrors: undefined,
            includeWarnings: undefined,
            companyId: (typeof filterParams.companyId === 'undefined' || filterParams.companyId == 'All') ? 0 : filterParams.companyId
        });
        log.debug('doLoadWarningSubCategories: ', modifiedFilterParams);
        dispatch(ERRORSWARNINGS_CONTROLLER.doLoadWarningSubCategories(modifiedFilterParams, callback, loading));
    };

    dispatcherProps.doActionOnFilters = (action, filter = {}, replaceTagValues = [], callback = () => { }) => {
        log.debug('doActionOnFilters(): ', action, filter);
        dispatch(ERRORSWARNINGS_CONTROLLER.doActionOnFilter(action, filter, replaceTagValues, callback));
    };

    dispatcherProps.doDownloadErrors = (filterCriteria = {}, callback = () => { }) => {
        log.debug('doDownloadErrors(): ');
        dispatch(ERRORSWARNINGS_CONTROLLER.doDownloadErrors(filterCriteria, callback));
    }

    dispatcherProps.doDownloadWarnings = (filterCriteria = {}, callback = () => { }) => {
        log.debug('doDownloadWarnings(): ');
        dispatch(ERRORSWARNINGS_CONTROLLER.doDownloadWarnings(filterCriteria, callback));
    }

    dispatcherProps.setSelection = (selection = {}) => {
        log.debug('setSelection(): ');
        dispatch(ERRORSWARNINGS_CONTROLLER.doSetSelection(selection));
    }

    dispatcherProps.doExportErrorsWarnings = (params) => {
        log.debug('doExportErrorsWarnings(): ');
        dispatch(ERRORSWARNINGS_CONTROLLER.doExportErrorsWarnings(params));
    }

    dispatcherProps.resetExportAllToast = () => {
        log.debug('resetExportAllToast(): ');
        dispatch(ERRORSWARNINGS_CONTROLLER.doResetExportAllToast());
    }

    dispatcherProps.doRescheduleCorrectionV3 = (errorIds, newTransactionDate, success, error) => {
        log.debug('doRescheduleCorrectionV3(): ');
        dispatch(ERRORSWARNINGS_CONTROLLER.doRescheduleCorrectionV3(errorIds, newTransactionDate, success, error));
    }

    dispatcherProps.doRescheduleNonCorrectionLatest = (errorIds, newTransactionDate, success, error) => {
        log.debug('doRescheduleNonCorrectionLatest(): ');
        dispatch(ERRORSWARNINGS_CONTROLLER.doRescheduleNonCorrectionLatest(errorIds, newTransactionDate, success, error));
    }

    dispatcherProps.doLoadErrors = (params, callback) => {
        log.debug('doLoadErrors(): ');
        dispatch(ERRORSWARNINGS_CONTROLLER.doLoadErrors(params, callback));
    }

    log.debug('mapStateToProps(): dispatcherProps: ', dispatcherProps);
    return dispatcherProps;
}

export default connect(mapStateToProps, mapDispatchersToProps)(ErrorsAndWarningsPage);
